<div class="summary-wrapper flex flex-row">
  @if (lazyRouteLoading.loading()) {
    <div class="summary-loading-overlay">
      <app-loading [loading]="true"></app-loading>
    </div>
  }
  <div class="left-section flex flex-row  col-{{leftSize}} ">
    <div class="{{separator? 'col-11': 'col-12'}}">
      <div class="side-container">
        <div>
          <ng-content select="[title]"></ng-content>
          @if (!hasTitle) {
            <div class="mb-4">
              @if (title === 'Main menu') {
                <h1>{{ title | translate }}</h1>
              } @else {
                <app-back-button
                  [title]="title"
                ></app-back-button>
              }
            </div>
          }
        </div>
        <div>
          <ng-content select="[left]"></ng-content>
          @if (!hasLeft) {
            <div class="items-container">
              @for (item of items; track item) {
                @if (showMenu(item)) {
                  <p-card
                    class="content-item"
                    [style]="getCardStyle(item)"
                    [title]="item.title | translate"
                  >
                    <a
                      [routerLink]="item.url"
                      [queryParams]="item.queryParams"
                      class="item-link"
                      (click)="onMenuClick(item.url)"
                    >
                      <div class="item-icon-box">
                        <img
                          [src]="item.icon"
                          [alt]="item.title | translate"
                          class="item-icon"/>
                      </div>
                      <span class="item-title">
              {{ item.title | translate }}
            </span>
                      <img
                        [src]="item.iconBack || item.icon"
                        [alt]="item.title | translate"
                        class="item-icon-back"
                      />
                    </a>
                  </p-card>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>

    @if (separator) {
      <div class="col-1">
        <div class="separator">
        </div>
      </div>
    }

  </div>


  <div class="col-{{rightSize}} right-section">
    <ng-content select="[right]"></ng-content>
    @if (!hasRight) {
      <div class="side-container">
        <h2>{{ 'Summary information' | translate }}</h2>
        {{ 'page is coming' | translate }}
      </div>
    }
  </div>
</div>
